import React from "react";

export default function GlassCard({ className = "", children }) {
  return (
    <div
      className={[
        "rounded-[28px] border border-[rgba(85,224,218,0.16)] bg-white/90 backdrop-blur-xl",
        "shadow-card",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}
